export default "__VITE_ASSET__0e66d5b0__"